<img src="assets/grupo-madero-logo.svg" alt="Logo Grupo Madero" width="300" height="150" />

<div class="fade-in-left text-center">
  <h2>Opss!</h2>
  <p>
    Não conseguimos carregar as informações. Verifique sua conexão e tente novamente em alguns segundos.
  </p>
</div>
